import { render, staticRenderFns } from "./CreateEquipe.vue?vue&type=template&id=87a6275e&"
import script from "./CreateEquipe.vue?vue&type=script&lang=ts&"
export * from "./CreateEquipe.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEquipe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports